export default {
  talk_to_us: 'Fale connosco:',
  send_us_email: 'Envie-nos um email:',
  visit_website: 'Visite o nosso website:',
  join_our_community: 'Junte-se à nossa comunidade para ofertas exclusivas e novidades!',
};
